import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import AdminIllustrations from '@/components/admin/admin-illustrations.vue'
import AdminIllustration from '@/components/admin/admin-illustration.vue'
import AdminCopies from '@/components/admin/admin-copies.vue'
import AdminCopy from '@/components/admin/admin-copy.vue'
import Copies from '@/components/public/copies.vue'
import Login from '@/components/login.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: Hello
    },
    {
      path: '/admin/illustrations',
      name: 'AdminIllustrations',
      component: AdminIllustrations,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/illustration/:slug',
      name: 'AdminIllustration',
      component: AdminIllustration,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/illustration',
      name: 'AdminNewIllustration',
      component: AdminIllustration,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/copies',
      name: 'AdminCopies',
      component: AdminCopies,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/copy/:id',
      name: 'AdminCopy',
      component: AdminCopy,
      meta: { requiresAuth: true }
    },
    ,
    {
      path: '/copies',
      name: 'Copies',
      component: Copies,
      meta: { requiresAuth: true }
    },
    {
      path: '/login/:returnpath',
      name: 'login',
      component: Login
    },
    {
      path: '*',
      name: 'DefaultPath',
      component: Hello
    },
  ]
});
/*
this.$Router.beforeEach((to, from, next) => {

} );
*/



// WEBPACK FOOTER //
// ./src/router/index.js